export const RECEIVE_NEWSLETTERS_ACIN_CAMPAIGNS = 6;
